<svg
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 242 40"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <defs>
    <linearGradient id="logo-gradient-nav" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" [attr.stop-color]="color || '#10B981'" />
      <stop offset="100%" [attr.stop-color]="color || '#10B981'" />
    </linearGradient>
  </defs>

  <g id="truck-icon" transform="translate(0, 4)">
    <path d="M2 12H10" [attr.stroke]="color || '#34D399'" stroke-width="2.5" stroke-linecap="round" opacity="0.4"/>
    <path d="M0 18H8" [attr.stroke]="color || '#34D399'" stroke-width="2.5" stroke-linecap="round" opacity="0.6"/>
    <path d="M3 24H11" [attr.stroke]="color || '#34D399'" stroke-width="2.5" stroke-linecap="round" opacity="0.8"/>
    
    <rect x="14" y="8" width="18" height="16" rx="3" fill="url(#logo-gradient-nav)"/>
    <path d="M33 13H38C39.6569 13 41 14.3431 41 16V24H33V13Z" [attr.fill]="color || '#10B981'"/>
    
    <circle cx="19" cy="27" r="3" [attr.fill]="color || '#1F2937'"/>
    <circle cx="36" cy="27" r="3" [attr.fill]="color || '#1F2937'"/>
    
    <path d="M35 15H38V19H33V17C33 15.8954 33.8954 15 35 15Z" fill="white" opacity="0.3"/>
  </g>

  <g id="brand-text" transform="translate(52, 28)">
    <text font-family="Lexend, sans-serif" font-size="22" font-weight="800" [attr.fill]="color || '#1F2937'" letter-spacing="-0.02em">
      Fletes <tspan [attr.fill]="color || '#10B981'">y</tspan> Cargas
    </text>
  </g>
</svg>
